import { createReducer, createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { API, SCOPE_STATE_LOCAL_AWARDS } from '../../constants';
import { application } from '../../services/application';
import {
  extendBuilderWithNotInterestedActions,
  extendListBuilder,
  generateListActions,
  generateNotInterestedActions,
  generateSearchActions,
  INITIAL_LIST_STATE_EXTENDED,
} from '../helpers/listActionsHelpers';

export const INITIAL_STATE = {
  ...INITIAL_LIST_STATE_EXTENDED,
  order: ['registrationDate', 'desc'],
  isAllExpanded: false,
  isListView: true,
  isActiveAwardsSelected: true,
};

const listActions = generateListActions({
  scope: SCOPE_STATE_LOCAL_AWARDS,
  apiMethod: {
    GET_LIST: API.STATE_LOCAL_AWARDS.GET_LIST,
    EXPORT_CSV: API.STATE_LOCAL_AWARDS.EXPORT_CSV,
  },
  getStore: (store) => store.stateLocalAwards,
});

const notInterestingActions = generateNotInterestedActions({
  scope: SCOPE_STATE_LOCAL_AWARDS,
  apiMethod: { ADD_NOT_INTERESTED: API.STATE_LOCAL_AWARDS.ADD_NOT_INTERESTED },
  getStore: (store) => store.stateLocalAwards,
});

const searchActions = generateSearchActions({
  scope: SCOPE_STATE_LOCAL_AWARDS,
  apiMethod: {
    SAVE_SEARCH: API.SAVED_SEARCH.CREATE,
    MODIFY_SEARCH: API.SAVED_SEARCH.MODIFY,
    SHARE_SEARCH: API.SHARED_SEARCH.CREATE,
  },
  getStore: (store) => store.stateLocalAwards,
});

const findOne = createAsyncThunk('stateLocalAwards/findOne', (params) => {
  return application.call(API.STATE_LOCAL_AWARDS.FIND_ONE, params);
});

const expandUnexpandAward = createAction('stateLocalAwards/expandUnexpandAward');
function onExpandUnexpandAward(state, action) {
  const copyItems = [...state.items];
  const index = copyItems.findIndex((i) => i.id === action.payload.id);
  if (index !== -1) {
    copyItems[index] = { ...copyItems[index], expanded: !copyItems[index]?.expanded };
  }
  return Object.assign(state, { items: copyItems });
}

const expandUnexpandAll = createAction('stateLocalAwards/expandUnexpandAll');
function onExpandUnexpandAll(state, action) {
  const copyItems = [...state.items];
  for (let index = 0; index < copyItems.length; index++) {
    let expandedResult = false;
    if (copyItems[index]?.expanded == null) {
      expandedResult = state.isAllExpanded;
    } else {
      expandedResult = action.payload?.overrideStatus ? state.isAllExpanded : copyItems[index]?.expanded;
    }
    copyItems[index] = { ...copyItems[index], expanded: expandedResult };
  }
  return Object.assign(state, { items: copyItems });
}

const handleIsAllExpanded = createAction('stateLocalAwards/handleIsAllExpanded');
function onHandleIsAllExpanded(state) {
  return Object.assign(state, { isAllExpanded: !state.isAllExpanded });
}

const handleIsListView = createAction('stateLocalAwards/handleIsListView');
function onHandleIsListView(state) {
  return Object.assign(state, { isListView: !state.isListView });
}

const setIsActiveAwardsSelected = createAction('stateLocalAwards/setIsActiveAwardsSelected');
function onSetActiveAwardsSelected(state, action) {
  return Object.assign(state, { isActiveAwardsSelected: action.payload });
}

export const actions = {
  ...listActions,
  ...notInterestingActions,
  ...searchActions,
  findOne,
  expandUnexpandAward,
  expandUnexpandAll,
  handleIsAllExpanded,
  handleIsListView,
  setIsActiveAwardsSelected,
};

export default createReducer(INITIAL_STATE, (builder) => {
  extendListBuilder(builder, actions)
    .addCase(expandUnexpandAward, onExpandUnexpandAward)
    .addCase(expandUnexpandAll, onExpandUnexpandAll)
    .addCase(handleIsAllExpanded, onHandleIsAllExpanded)
    .addCase(handleIsListView, onHandleIsListView)
    .addCase(setIsActiveAwardsSelected, onSetActiveAwardsSelected);
  extendBuilderWithNotInterestedActions(builder, actions);
});
